export default __webpack_public_path__ + "static/media/faceB.4a701ccb.png";